import Vue from 'vue'
import Vuex from 'vuex'
import { getLocalStorage } from '@/utils/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    areaList: []
  },
  getters: {
  },
  mutations: {
    changeLoginStatus (state) {
      state.isLogin = !!getLocalStorage('token')
    },
    setAreaList (state, data) {
      state.areaList = data
    }
  },
  actions: {

  },
  modules: {
  }
})
